import { render, staticRenderFns } from "./StockMovementIcon.vue?vue&type=template&id=ae7736e8"
import script from "./StockMovementIcon.vue?vue&type=script&lang=js"
export * from "./StockMovementIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports